import {type Line} from '../../../util/plotHelpers/types';
import {type UPlotMode} from '../../../util/rampFeatureFlags/linePlotDynamicConfigs';
import {getProfiledAlignedData} from './getAlignedData';
import {getFacetedData} from './getFacetedData';
import {getSeriesEntries} from './getSeriesEntries';

/**
 * Prepare the chart's lines and min/max bands once so the main and highlighted
 * layers can draw the same data. Aligned mode gives all lines a shared set of
 * X values; faceted mode keeps each line's own X values.
 */
export function prepareUPlotData(
  lines: Line[],
  xLogScale?: boolean,
  uPlotMode: UPlotMode = 'aligned'
) {
  const entries = getSeriesEntries(lines);
  // An empty chart uses aligned mode because uPlot's faceted mode needs a line to draw.
  if (uPlotMode === 'faceted' && lines.length > 0) {
    return {
      ...entries,
      uPlotMode,
      data: getFacetedData(entries, xLogScale),
      alignmentMeasurement: undefined,
    };
  }
  return {
    uPlotMode: 'aligned' as const,
    ...entries,
    ...getProfiledAlignedData(entries.seriesEntries, xLogScale),
  };
}

export type PreparedUPlotData = ReturnType<typeof prepareUPlotData>;
